import cmp from './CrashScreen'

export default cmp
